import React from 'react';
import { ChevronDown } from 'lucide-react';
import { COPY } from '../../i18n/copy';
import { useI18n } from '../../i18n/useI18n';

const EricaFAQ: React.FC = () => {
  const { lang } = useI18n();
  const c = COPY[lang];
  const [openIndex, setOpenIndex] = React.useState<number>(0);

  return (
    <section id="faq" className="bg-slate-50 py-20">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="mx-auto max-w-3xl text-center">
          <h2 className="text-3xl font-semibold tracking-tight text-slate-900 sm:text-4xl">
            {c.faq.title}
          </h2>
          <p className="mt-4 text-lg text-slate-600">{c.faq.subtitle}</p>
        </div>

        <div className="mx-auto mt-10 max-w-3xl space-y-3">
          {c.faq.items.map((item, idx) => {
            const isOpen = idx === openIndex;
            const contentId = `faq-${idx}-content`;
            const buttonId = `faq-${idx}-button`;
            return (
              <div
                key={item.q}
                className="overflow-hidden rounded-2xl border border-slate-200 bg-white shadow-sm"
              >
                <button
                  id={buttonId}
                  type="button"
                  aria-expanded={isOpen}
                  aria-controls={contentId}
                  onClick={() => setOpenIndex(isOpen ? -1 : idx)}
                  className="flex w-full items-center justify-between gap-4 px-6 py-5 text-left focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-slate-900"
                >
                  <span className="text-sm font-semibold text-slate-900">{item.q}</span>
                  <ChevronDown
                    className={`h-5 w-5 flex-shrink-0 text-slate-500 transition-transform ${
                      isOpen ? 'rotate-180' : ''
                    }`}
                  />
                </button>
                <div
                  id={contentId}
                  role="region"
                  aria-labelledby={buttonId}
                  className={`${isOpen ? 'block' : 'hidden'} border-t border-slate-200 px-6 py-5`}
                >
                  <p className="text-sm leading-relaxed text-slate-600">{item.a}</p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default EricaFAQ;

